// src/components/ui/Input.js
import React from 'react';

const Input = ({ label, error, icon: I, suffix, ...p }) => (
  <div className="space-y-1.5">
    {label && (
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300">
        {label}
      </label>
    )}
    <div className="relative">
      {I && (
        <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400">
          <I size={18} />
        </div>
      )}
      <input
        {...p}
        className={`w-full px-4 ${I ? 'pl-11' : ''} ${suffix ? 'pr-11' : ''} py-3 bg-gray-50 dark:bg-gray-800 border-2 ${
          error
            ? 'border-red-300'
            : 'border-gray-100 dark:border-gray-700 focus:border-rose-300 dark:focus:border-rose-500'
        } rounded-xl dark:text-gray-100 focus:outline-none transition`}
      />
      {suffix && <div className="absolute right-3 top-1/2 -translate-y-1/2">{suffix}</div>}
    </div>
    {error && <p className="text-red-500 text-sm">{error}</p>}
  </div>
);

export default Input;
